import { gql } from "@apollo/client";

export const getLensAutomationToolMaintenanceStatus = gql`
    query getLensAutomationToolMaintenanceStatus {
        getLensAutomationToolMaintenanceStatus {
            status
        }
    }
`;
